enum NotificationType {
  cast = "キャスト",
  driver = "ドライバー",
  guest = "お客様",
  trouble = "トラブル報告",
}

export default NotificationType;
